import {phone, PhoneResult} from 'phone';

export function checkPhone(value: string): PhoneResult {
  return phone(value);
}
